import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\n",{ moduleName: "bullitt-time-results/templates/index.hbs" })